'use es6';

import { createSelector } from 'reselect';
import { getHasDecoupledHeadersAndFootersAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { calculateHoverPositions, calculateHoverPositionsForDecoupledHeaders } from 'InpageEditorUI/lib/layoutSection/hoverPositionCalculator';
export const getCalculateHoverPositionsCalculator = createSelector(getHasDecoupledHeadersAndFootersAccess, hasDecoupledHeadersAndFootersAccess => {
  if (hasDecoupledHeadersAndFootersAccess) {
    return calculateHoverPositionsForDecoupledHeaders;
  }
  return calculateHoverPositions;
});